import React, { useState, useEffect, useMemo } from "react";
import axios from "axios";
import FormCanvas from "./EntryFormChild/FormCanvas";
import Side from "./EntryFormChild/Side";
import FormPreview from "./EntryFormChild/FormPreview";
import { GreyBackgroundButton, RedBackgroundButton } from "../../../Global/GlobalButton";
import "./EntryForm.css";
import { useDispatch, useSelector } from "react-redux";
import { removeFieldFromEntryPayload, resetEntryState, SET_ENTRY_FORM_ID } from "../../../Redux/Users/action";
import { useNavigate } from "react-router-dom";
import { EXCHNAGE_URL } from "../../../../Url/Url";
import { toast } from "react-toastify";
import { setEntryFieldPayload } from "../../../Redux/Users/EntryFieldAction";

export const EntryForm = ({setSelectedButton, updatedField,setHighestAllowedStep, eventBanner,
  eventLogo,
  eventName,
  closingTime,
  closingDate}) => {

  const [fields, setFields] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [entryFormId, setEntryFormId] = useState(null);
  const [fetchedForms, setFetchedForms] = useState({});
  const [savedFormId, setSavedFormId] = useState(null);
  const [addedFields, setAddedFields] = useState([])
  const [formSchema, setFormSchema] = useState([]);
  const [copiedFields, setCopiedFields] = useState([]);
  const [formData, setFormData] = useState({});
  const [copiedDefaultFields, setCopiedDefaultFields] = useState({})
  const [draggedIndex, setDraggedIndex] = useState(null);
  const [draggedCategory, setDraggedCategory] = useState(null);

  const dispatch = useDispatch();
  console.log(eventBanner,
    eventLogo,
    eventName,
    closingTime,
    closingDate,"kkkkkkk")
  const eventIdGet = useSelector((state) => state?.users?.id);
  const eventId = String(eventIdGet);
  const entryFieldPayload = useSelector((state) => state.entry.fieldPayload);
  const navigate = useNavigate();
  const defaultFields = useMemo(() => [
    {
        type: "dropdown",
        label: "Category",
        dataName: `category-${Date.now()}`,
        placeholder: "Enter category...",
        required: true,
        charLimitRequired: false,
        wordLimit: "",
        fieldSize: "100%",
        defaultValue: "",
        isDefault: true,
        visible: true,
    },
    {
        type: "text",
        label: "Title of the Entry",
        dataName: `title-${Date.now()}`,
        placeholder: "Enter title...",
        required: true,
        charLimitRequired: false,
        wordLimit: "",
        fieldSize: "100%",
        defaultValue: "",
        isDefault: true,
        visible: true,
    },
    // {
    //     type: "email",
    //     label: "Email",
    //     dataName: `emailDef-${Date.now()}`,
    //     placeholder: "Enter Email...",
    //     required: true,
    //     charLimitRequired: false,
    //     wordLimit: "",
    //     fieldSize: "100%",
    //     defaultValue: "",
    //     isDefault: true,
    //     visible: true,
    // },
    // {
    //     type: "text",
    //     label: "Name",
    //     dataName: `name-${Date.now()}`,
    //     placeholder: "Enter Name...",
    //     required: true,
    //     charLimitRequired: false,
    //     wordLimit: "",
    //     fieldSize: "100%",
    //     defaultValue: "",
    //     isDefault: true,
    //     visible: true,
    // },
    // {
    //     type: "tel",
    //     label: "Phone Number",
    //     dataName: `telDef-${Date.now()}`,
    //     placeholder: "Enter Phone Number...",
    //     required: true,
    //     charLimitRequired: false,
    //     wordLimit: "",
    //     fieldSize: "100%",
    //     defaultValue: "",
    //     isDefault: true,
    //     visible: true,
    // },
    // {
    //     type: "text",
    //     label: "Designation",
    //     dataName: `designation-${Date.now()}`,
    //     placeholder: "Enter Designation...",
    //     required: true,
    //     charLimitRequired: false,
    //     wordLimit: "",
    //     fieldSize: "100%",
    //     defaultValue: "",
    //     isDefault: true,
    //     visible: true,
    // }
], []); 

  const addField = (type) => {
    const newField = {
      label: { type: "label", label: "Label Text", required: false, visible: true, dataName: `label-${Date.now()}`, adminLabel: "Label Admin Label", description: "<p>This is an HTML description for the label.</p>", size: "h1" },
      text: { type: "text", label: "Single Line Text", dataName: `text-${Date.now()}`, placeholder: "Enter text...", required: false, visible: true, charLimitRequired: false, wordLimit: "", fieldSize: "100%" },
      textarea: { type: "textarea", label: "Paragraph Text", dataName: `textarea-${Date.now()}`, charLimitRequired: false, required: false, visible: true, wordLimitRequired: false, charLimit: "", wordLimit: "", fieldSize: "100%" },
      radio: { type: "radio", label: "Radio Button", required: false, visible: true, dataName: `radio-${Date.now()}`, options: ["Option 1", "Option 2"] },
      checkbox: { type: "checkbox", label: "Checkbox", required: false, visible: true, dataName: `checkbox-${Date.now()}`, options: ["Option 1", "Option 2"] },
      dropdown: { type: "dropdown", label: "Dropdown", required: false, visible: true, dataName: `dropdown-${Date.now()}`, options: ["Option 1", "Option 2", "Option 3"] },
      email: { type: "email", label: "Email", required: false, visible: true, dataName: `email-${Date.now()}`, placeholder: "Enter email..." },
      tel: { type: "tel", label: "Phone Number", required: false, visible: true, dataName: `tel-${Date.now()}`, placeholder: "Enter phone number..." },
      date: { type: "date", label: "Date Picker", required: false, visible: true, dataName: `date-${Date.now()}` },
      country: { type: "country", required: false, visible: true, label: "Country List", dataName: `country-${Date.now()}`, options: ["USA", "India", "Canada"] },
      file: { type: "file", label: "File Upload", required: false, visible: true, dataName: `file-${Date.now()}` },
    };



    if (newField[type]) {
      console.log("Before setting, addedFields is:", addedFields);
      setAddedFields((prevFields) => {
        console.log("Inside setAddedFields, prevFields:", prevFields);
        if (Array.isArray(prevFields)) {
          const updatedFields = [...prevFields, newField[type]];
          console.log("Updated addedFields:", updatedFields);
          return updatedFields;
        } else {
          console.error("addedFields is not an array", prevFields);
          return [newField[type]];
        }
      });
    } else {
      console.error("Invalid field type:", type);
    }
  };

  const copyField = (index) => {
    const fieldToCopy = addedFields[index];
    let copiedField;
    if (entryFieldPayload?.length > 0) {
      const matchingPayload = entryFieldPayload.find(item => item.dataName === fieldToCopy.dataName);

      if (matchingPayload) {
        copiedField = {
          ...fieldToCopy,
          dataName: `${fieldToCopy.dataName}_copy_${Date.now()}`,
          label: `copy ${fieldToCopy.label}`,
          value: "",
          type: matchingPayload.type,
          addedSubfields: matchingPayload.addedSubfields || [],
          hoverHint: matchingPayload.hoverHint || "",
          options: [...(matchingPayload.options || [])],
          required: matchingPayload.required ?? false,
          includeOther: matchingPayload.includeOther ?? false,
          isRequiredIf: matchingPayload.isRequiredIf ?? false,
          requiredFieldValue: [...(matchingPayload.requiredFieldValue || [])],
          requiredCondition: [...(matchingPayload.requiredCondition || [])],
          requiredConditionValue: [...(matchingPayload.requiredConditionValue || [])],
          visible: matchingPayload.visible ?? true,
          isVisibleIf: matchingPayload.isVisibleIf ?? false,
          visibleFieldValue: [...(matchingPayload.visibleFieldValue || [])],
          visibleCondition: [...(matchingPayload.visibleCondition || [])],
          visibleConditionValue: [...(matchingPayload.visibleConditionValue || [])],
          isVisibleCheckedInJudging: matchingPayload.isVisibleCheckedInJudging ?? false,
          visibleInJudgingFieldValue: matchingPayload.visibleInJudgingFieldValue || "",
          visibleInJudgingCondition: matchingPayload.visibleInJudgingCondition || "Equals",
          visibleInJudgingInConditionValue: matchingPayload.visibleInJudgingInConditionValue || "",
          renderlabel: matchingPayload.renderlabel || "",
          renderDataName: matchingPayload.renderDataName || "",
          selectedLabelPosition: matchingPayload.selectedLabelPosition || "top",
          selectedFieldSize: matchingPayload.selectedFieldSize || "100%",
        };
        console.log("Copied Field with conditions from fieldPayload:", copiedField);
        const copiedFieldPayload = {
          ...matchingPayload,
          dataName: copiedField.dataName,
          label: copiedField.label,
        };
        console.log("Dispatching Copied Field Payload:", copiedFieldPayload);
        dispatch(setEntryFieldPayload(copiedFieldPayload));
      } else {
        copiedField = {
          ...fieldToCopy,
          dataName: `${fieldToCopy.dataName}_copy_${Date.now()}`,
          label: `copy ${fieldToCopy.label}`,
          value: "",
        };
        console.log("Copied Field without matching conditions:", copiedField);
      }
    }
    else {
      copiedField = {
        ...fieldToCopy,
        dataName: `${fieldToCopy.dataName}_copy_${Date.now()}`,
        label: `copy ${fieldToCopy.label}`,
        value: "",
      };
      console.log("Copied Field (fieldPayload is empty):", copiedField);
    }

    setCopiedFields((prevCopiedFields) => [...prevCopiedFields, copiedField]);

  };



console.log(defaultFields,"def")

  const copyNormalField = (index) => {
    const fieldToCopy = defaultFields[index];
    console.log(fieldToCopy, "fieldToCopy");
    let copiedField;
    if (entryFieldPayload?.length > 0) {
      const matchingPayload = entryFieldPayload.find(item => item.dataName === fieldToCopy.dataName);
      console.log(matchingPayload,"fieldToCopy")
      if (matchingPayload) {
        copiedField = {
          ...fieldToCopy,
          dataName: `${fieldToCopy.dataName}_copy_${Date.now()}`,
          label: `copy ${fieldToCopy.label}`,
          value: "",
          type: matchingPayload.type,
          addedSubfields: matchingPayload.addedSubfields || [],
          hoverHint: matchingPayload.hoverHint || "",
          options: [...(matchingPayload.options || [])],
          required: matchingPayload.required ?? false,
          includeOther: matchingPayload.includeOther ?? false,
          isRequiredIf: matchingPayload.isRequiredIf ?? false,
          requiredFieldValue: [...(matchingPayload.requiredFieldValue || [])],
          requiredCondition: [...(matchingPayload.requiredCondition || [])],
          requiredConditionValue: [...(matchingPayload.requiredConditionValue || [])],
          visible: matchingPayload.visible ?? true,
          isVisibleIf: matchingPayload.isVisibleIf ?? false,
          visibleFieldValue: [...(matchingPayload.visibleFieldValue || [])],
          visibleCondition: [...(matchingPayload.visibleCondition || [])],
          visibleConditionValue: [...(matchingPayload.visibleConditionValue || [])],
          isVisibleCheckedInJudging: matchingPayload.isVisibleCheckedInJudging ?? false,
          visibleInJudgingFieldValue: matchingPayload.visibleInJudgingFieldValue || "",
          visibleInJudgingCondition: matchingPayload.visibleInJudgingCondition || "Equals",
          visibleInJudgingInConditionValue: matchingPayload.visibleInJudgingInConditionValue || "",
          renderlabel: matchingPayload.renderlabel || "",
          renderDataName: matchingPayload.renderDataName || "",
          selectedLabelPosition: matchingPayload.selectedLabelPosition || "top",
          selectedFieldSize: matchingPayload.selectedFieldSize || "100%",
        };
        console.log("Copied Field with conditions from fieldPayload:", copiedField);
        const copiedFieldPayload = {
          ...matchingPayload,
          dataName: copiedField.dataName,
          label: copiedField.label,
        };
        console.log("Dispatching Copied Field Payload:", copiedFieldPayload);
        dispatch(setEntryFieldPayload(copiedFieldPayload));
      } else {
        copiedField = {
          ...fieldToCopy,
          dataName: `${fieldToCopy.dataName}_copy_${Date.now()}`,
          label: `copy ${fieldToCopy.label}`,
          value: "",
        };
        console.log("Copied Field without matching conditions:", copiedField);
      }
    }
    else {
      copiedField = {
        ...fieldToCopy,
        dataName: `${fieldToCopy.dataName}_copy_${Date.now()}`,
        label: `copy ${fieldToCopy.label}`,
        value: "",
      };
      console.log("Copied Field (fieldPayload is empty):", copiedField);
    }

    setCopiedFields((prevCopiedFields) => [...prevCopiedFields, copiedField]);

  };
  useEffect(() => {
    console.log("copiedFields updated:", copiedFields);
  }, [copiedFields]);

  const removeField = (index) => {
    const fieldToRemove = addedFields[index];
    setAddedFields(addedFields.filter((_, i) => i !== index));
    dispatch(removeFieldFromEntryPayload(fieldToRemove.dataName));
  };

  const removeFieldFromCopied = (index) => {
    const fieldToRemove = copiedFields[index];
    setCopiedFields(copiedFields.filter((_, i) => i !== index));
    dispatch(removeFieldFromEntryPayload(fieldToRemove.dataName));
  };

  // const removeDefaultFieldFromCopied = (index) => {
  //   const fieldToRemove = copiedDefaultFields[index];
  //   setCopiedDefaultFields(copiedDefaultFields.filter((_, i) => i !== index));
  //   dispatch(removeFieldFromEntryPayload(fieldToRemove.dataName));
  // };

  const updateField = (updatedFields) => {
    const updatedFormFields = fields.map((field) => {
      const updatedField = updatedFields.find((updated) => updated.dataName === field.dataName);
      console.log(updatedFields, "asdasdasd")
      if (updatedField) {
        return { ...field, ...updatedField };
      }
      return field;
    });

    setFields(updatedFormFields);
  };

  const updateAddedField = (index, updatedField) => {
    setAddedFields((prevFields) => {
      const newFields = [...prevFields];
      newFields[index] = { ...newFields[index], ...updatedField };
      return newFields;
    });
  };

  const updateCopiedField = (updatedFieldData) => {
    const updatedCopiedFields = copiedFields.map((field) => {
      if (field.dataName === updatedFieldData.dataName) {
        return { ...field, ...updatedFieldData };
      }
      return field;
    });
    setCopiedFields(updatedCopiedFields);
  };

  console.log(formData, "formDataaaaa")
  const handleSaveForm = () => {
      // setHighestAllowedStep((prev) => Math.max(prev, 4));
    // setSelectedButton(4);
    dispatch(resetEntryState());

    if (!eventId) {
      console.error("Event ID is missing.");
      toast.error("Entry Form Failed, EventId Missing")
      return;
    }
    const formSchemaArray = Object.values(formData);
    const formPayload = { form_schema: formSchemaArray, eventId };

    axios.post(`${EXCHNAGE_URL}/entryForm`, formPayload, {
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
      .then((response) => {
        const newEntryFormId = response.data.id;
        setEntryFormId(newEntryFormId);
        // dispatch({ type: SET_ENTRY_FORM_ID, payload: newEntryFormId });
        // setShowModal(true);
        toast.success("Entry Form Submitted Successfully.")
        dispatch(resetEntryState());
        navigate("/dashboard")
      })
      .catch((error) => {
        console.error("Error creating form:", error);
        toast.error("Error creating form. Please try again.");
      });
  };

  useEffect(() => {
    const initialData = formSchema.reduce((acc, field) => {
      acc[field.dataName] = {
        type:field.type,
        value: field.defaultValue || "",
        isConditionMet: true,
        isRequired: field.required || false,
        label: field.label,
        isVisible: field.visible || true,
        dataName: field.dataName || "",
        labelPosition: field.labelPosition || "",
        options:field.options || "",
        visible:field.visible,
      };
      return acc;
    }, {});

    if (JSON.stringify(formData) !== JSON.stringify(initialData)) {
      setFormData(initialData);
    }
  }, [formSchema]);

  console.log(formData, "daadaddaddadadadadda")

  useEffect(() => {
    const mergeFormDataWithPayload = () => {
      const updatedMergeData = { ...formData };
      entryFieldPayload.forEach(field => {
        const { dataName, ...rest } = field;
        if (updatedMergeData[dataName]) {
          updatedMergeData[dataName] = {
            ...updatedMergeData[dataName],
            ...rest,
          };
        } else {
          updatedMergeData[dataName] = {
            value: '',
            isConditionMet: true,
            isRequired: false,
            isVisible: true,
            ...rest,
          };
        }
      });

      return updatedMergeData;
    };

    const updatedMergeData = mergeFormDataWithPayload();
    console.log("Mergeeeeeeeeee", updatedMergeData);
    if (JSON.stringify(formData) !== JSON.stringify(updatedMergeData)) {
      setFormData(updatedMergeData);
    }
  }, [entryFieldPayload, formData]);


  useEffect(() => {
    setFields([...defaultFields]);
  }, []);

  useEffect(() => {
    setFields([...defaultFields]);
    setAddedFields([]); 
  }, []);

  useEffect(() => {
    if (Array.isArray(fields) && Array.isArray(addedFields) && Array.isArray(copiedFields)) {
      const newFormSchema = [...fields, ...addedFields, ...copiedFields];
      console.log("Merged formSchema:", newFormSchema); // Debugging step
      setFormSchema(newFormSchema);
    }
    else if (formSchema.length === 0) {
      setFormSchema([...fields])
    }
  }, [fields, addedFields, copiedFields]);

  const handleDragStart = (e, index, category) => {
    setDraggedIndex(index);
    setDraggedCategory(category);
    e.target.style.opacity = "0.5";
    e.target.style.cursor = "move";
  };

  const handleDragEnd = (e) => {
    e.target.style.opacity = "";
    e.target.style.cursor = "";
  };

  // const handleDrop = (e, dropIndex, targetCategory) => {
  //   e.preventDefault();
  //   if (draggedCategory === targetCategory && draggedIndex === dropIndex) return;

  //   let sourceCategory;
  //   let targetCategoryState;
  //   let setState;
  //   if (draggedCategory === "fields") {
  //     sourceCategory = fields;
  //     targetCategoryState = [...fields];
  //     setState = setFields;
  //   } else if (draggedCategory === "addedFields") {
  //     sourceCategory = addedFields;
  //     targetCategoryState = [...addedFields];
  //     setState = setAddedFields;
  //   } else if (draggedCategory === "copiedFields") {
  //     sourceCategory = copiedFields;
  //     targetCategoryState = [...copiedFields];
  //     setState = setCopiedFields;
  //   }
  //   const [movedField] = targetCategoryState.splice(draggedIndex, 1);
  //   targetCategoryState.splice(dropIndex, 0, movedField);
  //   setState(targetCategoryState);

  //   setDraggedIndex(null);
  //   setDraggedCategory(null);
  // };

  const handleDrop = (e, dropIndex, targetCategory) => {
    e.preventDefault();
    if (draggedIndex === null || draggedCategory === null) return;

    // Determine source and target arrays
    let sourceArray, setSourceArray, targetArray, setTargetArray;

    switch (draggedCategory) {
      case 'fields':
        sourceArray = fields;
        setSourceArray = setFields;
        break;
      case 'addedFields':
        sourceArray = addedFields;
        setSourceArray = setAddedFields;
        break;
      case 'copiedFields':
        sourceArray = copiedFields;
        setSourceArray = setCopiedFields;
        break;
      default:
        return;
    }

    switch (targetCategory) {
      case 'fields':
        targetArray = fields;
        setTargetArray = setFields;
        break;
      case 'addedFields':
        targetArray = addedFields;
        setTargetArray = setAddedFields;
        break;
      case 'copiedFields':
        targetArray = copiedFields;
        setTargetArray = setCopiedFields;
        break;
      default:
        return;
    }

    // If dragging within the same category
    if (draggedCategory === targetCategory) {
      const newArray = [...sourceArray];
      const [movedItem] = newArray.splice(draggedIndex, 1);
      newArray.splice(dropIndex, 0, movedItem);
      setSourceArray(newArray);
    } else {
      // Dragging between categories
      const newSourceArray = [...sourceArray];
      const [movedItem] = newSourceArray.splice(draggedIndex, 1);
      const newTargetArray = [...targetArray];
      newTargetArray.splice(dropIndex, 0, movedItem);

      setSourceArray(newSourceArray);
      setTargetArray(newTargetArray);
    }

    setDraggedIndex(null);
    setDraggedCategory(null);
  };

  return (
    <div>
      <div className="formapp">
        <Side addField={addField} />
        <div className="canvas-save">
          <FormCanvas
            fields={fields}
            addedFields={addedFields}
            updateField={updateField}
            updatedField={updatedField}
            removeField={removeField}
            copiedFields={copiedFields}
            disableRequiredCheckbox={true}
            formSchema={formSchema}
            copyField={copyField}
            copyNormalField={copyNormalField}
            removeFieldFromCopied={removeFieldFromCopied}
            updateAddedField={updateAddedField}
            updateCopiedField={updateCopiedField}
            handleDrop={handleDrop}
            handleDragStart={handleDragStart}
            handleDragEnd={handleDragEnd}
          />
          <div className="registratation_button">
            <GreyBackgroundButton onClick={() => setShowModal(true)}>Preview</GreyBackgroundButton>
            <RedBackgroundButton onClick={handleSaveForm}>Publish Event</RedBackgroundButton>
          </div>
        </div>
      </div>

      {/* {/ Form Preview Modal /} */}
      <FormPreview
        formSchema={formSchema}
        showModal={showModal}
        handleClose={() => setShowModal(false)} // Close modal
        eventBanner={eventBanner}
        eventLogo={eventLogo}
        closingTime={closingTime}
        closingDate={closingDate}
        eventName={eventName}
      />
    </div>
  );
};
